export default __webpack_public_path__ + "static/media/Icons_Withdraw Icon.3e2d2079.svg";